export const PILOT_DATA_FRAMES_TABLE_FRENCH_LOCALE = {
  globalSearchPlaceholder: "Rechercher une valeur...",
  empty: "Aucun logs trouvé...",
  headers: {
    id: "Log Id",
    arrivalDate: "Date d'arrivée",
    pilotSentDate: "Date d'envoie",
    frame: "Frame",
    pilotHwId: "Pilote Hw Id",
    pilotIp: "IP du pilote",
    typeDescription: "Type",
    typeClassDescription: "Classe",
  },
  filters: {
    placeholders: {
      id: "Rechercher par log id...",
      arrivalDate: "Rechercher par date d'arrivée...",
      pilotSentDate: "Rechercher par date d'envoie...",
      frame: "Rechercher par frame...",
      pilotHwId: "Rechercher par pilote hw id...",
      pilotIp: "Rechercher par ip du pilote...",
      typeDescription: "Rechercher par type...",
      typeClassDescription: "Rechercher par classe...",
    },
  },
};
